<template>
  <VCardImportFormSection title="Home Info">
    <v-row>
      <v-col cols="4">
        Home City
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.home_address.city"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Home Postal
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.home_address.postal"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Home State
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.home_address.state"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Home Street
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.home_address.street"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Home Phone
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.home_phone"
          :items="items"
        />
      </v-col>
    </v-row>
  </VCardImportFormSection>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { VCardSectionMixin } from '@/bundles/Contact/mixins/VCardSectionMixin';

export default defineComponent({
  name: 'VCardImportHomeInfo',
  mixins: [VCardSectionMixin],
});
</script>
